const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  roleid: state => state.user.roleid,
  nickname: state => state.user.name,
  welcome: state => state.user.welcome,
  permissions: state => state.user.permissions,
  userInfo: state => state.user.info,
  menus: state => state.permission.menus,
  homePagePermission: state => state.permission.homePagePermission,
  projectPagePermission: state => state.permission.projectPagePermission,
  homeRouters: state => state.permission.homeRouters,
  projectRouters: state => state.permission.projectRouters,
  multiTab: state => state.app.multiTab,
  projectId: state => state.project.projectId,
  projectData: state => state.project.projectData,
  projectHospitals: state => state.project.projectHospitals,
  isProjectCreater: state => state.project.isProjectCreater,
  imageType: state => state.project.projectData.imageType,
  projectUsers: state => state.project.projectUsers,
  globalLabelTrees: state => state.project.globalLabelTrees,
  flatGlobalLabelList: state => state.project.flatGlobalLabelList,
  localLabelTrees: state => state.project.localLabelTrees,
  flatLocalLabelList: state => state.project.flatLocalLabelList,
  diagnoseModels: state => state.project.diagnoseModels,
  dataId: state => state.data.dataId,
}

export default getters
